import { styled } from 'mz-ui-kit';
import { getScreenStyles } from 'mz-ui-kit/utils';

export const Container = styled('div', ({ $palette }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '24px',
  width: '100%',
  padding: '16px',
  marginBottom: '40px',
  marginTop: '30px',
  borderRadius: '8px',
  background: `${$palette('primary').setAlpha(0.15)}`,
  boxSizing: 'border-box',
  ...getScreenStyles('xs', {
    width: 'auto',
    gap: '16px',
    padding: '12px',
    marginLeft: '16px',
    marginRight: '16px',
  }),
}));

export const IconWrapper = styled('div', {
  position: 'relative',
  flexShrink: 0,
});

export const IconCircle = styled('div', ({ $palette }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: '56px',
  height: '56px',
  borderRadius: '50%',
  color: `${$palette('white')}`,
  background: `${$palette('primary')}`,
}));

export const NewBadge = styled('span', ({ $palette }) => ({
  position: 'absolute',
  top: '-10px',
  left: '-8px',
  padding: '3px 8px',
  borderRadius: '6px',
  background: `${$palette('primary')}`,
  color: `${$palette('white')}`,
  fontSize: '10px',
  fontWeight: 700,
  lineHeight: '14px',
  letterSpacing: '0.4px',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
}));

export const Content = styled('div', ({ $palette }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  flex: '1 0 0',
  minWidth: 0,
  wordBreak: 'break-word',
  color: `${$palette('text')}`,
}));

export const Title = styled('p', {
  margin: 0,
  fontWeight: 600,
  fontSize: '18px',
  lineHeight: '26px',
  ...getScreenStyles('xs', {
    fontSize: '16px',
    lineHeight: '24px',
  }),
});

export const Text = styled('p', {
  margin: 0,
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '22px',
});

export const Strong = styled('span', {
  fontWeight: 700,
});
